import { render, staticRenderFns } from "./EditFooterSocialBlock.vue?vue&type=template&id=7756d73d&scoped=true&"
import script from "./EditFooterSocialBlock.vue?vue&type=script&lang=js&"
export * from "./EditFooterSocialBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditFooterSocialBlock.vue?vue&type=style&index=0&id=7756d73d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7756d73d",
  null
  
)

export default component.exports